module.exports = __webpack_public_path__ + "img/banner-mobile.21c8a764.jpg";